import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { OrganizationId } from "@goose/schema/Salesforce";

import { QueryState } from "~/components/QueryState";
import { TRPCClientErrorDisplay } from "~/components/TRPCClientErrorDisplay";
import { Spinner } from "~/components/ui/Spinner";
import { useTRPC } from "~/lib/trpc";

export const Route = createFileRoute("/_authenticated/admin/contacts/random")({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      organizationId: OrganizationId.optional().parse(search["organizationId"]),
    };
  },
});

function RouteComponent() {
  const { organizationId } = Route.useSearch();

  const trpc = useTRPC();
  const query = useQuery(trpc.contacts.random.queryOptions({ organizationId }));

  return (
    <QueryState
      result={query}
      loading={<Spinner size="lg" />}
      error={(error) => <TRPCClientErrorDisplay error={error} />}
    >
      {(params) => (
        <Navigate
          to="/admin/organizations/$organizationId/contacts/$contactId"
          params={params}
          replace
        />
      )}
    </QueryState>
  );
}
